import { render, staticRenderFns } from "./MyCoupons.vue?vue&type=template&id=a11b853e&scoped=true"
import script from "./MyCoupons.vue?vue&type=script&lang=js"
export * from "./MyCoupons.vue?vue&type=script&lang=js"
import style0 from "./MyCoupons.vue?vue&type=style&index=0&id=a11b853e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11b853e",
  null
  
)

export default component.exports